<template>
  <b-container>
    <b-row>
      <b-col>
        <div class="form form-sm mx-auto text-center">
          <img
            src="@assets/img/logo-lg--colored.png"
            alt="LimeIQ"
            class="form-logo mx-auto"
            width="401"
            height="120"
          />

          <h2 class="mt-4 text-primary">Verify Employee</h2>
          <p>Please wait...</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { AuthenticationService } from '@services'

export default {
  methods: {
    redirectOnApproval() {
      if (this.$route.query.token) {
        window.location.href = `${process.env.VUE_APP_BACKEND_URL}/auth/login/verify?token=${this.$route.query.token}`

        return
      } else {
        this.$router.push({
          name: 'Users'
        })
      }
    }
  },
  mounted() {
    AuthenticationService.approveSignup({
      uid: this.$route.params.uid,
      key: this.$route.params.key
    })
      .then((response) => {
        const data = response.data.data

        this.$toasted.show(data.message)
        this.redirectOnApproval()
      })
      .catch(() => {
        this.redirectOnApproval()
      })
  }
}
</script>
